<ion-breadcrumbs
  color="primary"
  class="ion-margin-top ion-padding-bottom"
  [maxItems]="4"
  [itemsAfterCollapse]="2"
>
  @for (link of links; track link) {
    @if (link) {
      <ion-breadcrumb [routerLink]="link?.url" [title]="link?.title">
        {{ link?.label }}
      </ion-breadcrumb>
    }
  }
</ion-breadcrumbs>
